import { Helmet } from 'react-helmet';

const SEOMetaTags = ({
    title = "TimbrLux Stays",
    description = "At TimbrLux Stays, we believe a great stay is more than a getaway — it's a feeling. Beautifully designed vacation home hosted with genuine warmth.",
    keywords = "vacation rentals, luxury stays, vacation homes, TimbrLux Stays, getaway, travel, accommodation",
    image = "/image/og-image.jpg",
    url = "https://www.timbrluxstays.com",
    type = "website",
    noindex = false,
    ogTitle,
    ogDescription
}) => {
    // Avoid duplicating the brand name when the page title already includes it.
    const fullTitle = /timbrlux\s*stays/i.test(title)
        ? title
        : `${title} | TimbrLux Stays`;

    // Optional dedicated OG/Twitter copy; fall back to the page title/description.
    const socialTitle = ogTitle || fullTitle;
    const socialDescription = ogDescription || description;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            {noindex && <meta name="robots" content="noindex, follow" />}

            {/* Open Graph */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={socialTitle} />
            <meta property="og:description" content={socialDescription} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={socialTitle} />
            <meta name="twitter:description" content={socialDescription} />
            <meta name="twitter:image" content={image} />

            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEOMetaTags;
